import React, { useCallback, useEffect, useState } from "react";
import { DataGrid } from '@mui/x-data-grid';
import { Card } from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import { Container } from "reactstrap";
import Button from "@mui/material/Button";
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import AddTeamMember from "../../Components/ProjectSubmission/addTeamMember";
import { Action, DefaultPerPageValue, PerPage } from "../../constants/Common";
import { Role } from "../../constants/Role";
import { getUserList } from "../../api/casp/user";
import { Skeleton } from "@mui/material";
import { debounce } from "@mui/material"
import { Col, Row } from "reactstrap"
import NodataFound from "../../Components/Common/NoDataFound";
import Ticket from "../../assets/images/icons/ticket.png";
import { useSelector } from "react-redux";
import { hasModulePermission } from "../../helpers/permission";
import { Modules } from "../../constants/Module";
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import SweetAlert from "react-bootstrap-sweetalert";
import { removeProjectUser } from "../../api/casp/project";
import { toast } from "react-toastify";
import { ProjectStatuses } from "../../constants/Status";
import { withTranslation } from "react-i18next";
import UserProfile from "../casp/common/userProfile";
import { PaginationComponent } from "../../Components/casp/common/PaginationComponent";
import AddTeamMemberDrawer from "../casp/user/addTeamMemberDrawer";
import { deleteContact, getContactList } from "../../api/casp/contact";
import { EditOutlined } from "@mui/icons-material";
import EditIcon from "../../assets/images/icons/edit-line.svg";

const DataTable = ({ projectId, disabled, projectStatus = ProjectStatuses.DRAFT, t }) => {
    const [isTeamMemberPopupOpen, setTeamMemberPopupOpen] = useState(false);
    const [teamMembers, setTeamMembers] = useState([])
    const [isLoading, setIsLoading] = useState(false);
    const [mounted, setMounted] = useState(false);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(DefaultPerPageValue);
    const [rowCountState, setRowCountState] = useState(0);
    const [sortOrder, setSortOrder] = useState()
    const [sortDirection, setSortDirection] = useState()
    const [searchValue, setSearchValue] = useState()
    const [searchField, setSearchField] = useState()
    const [triggerElement, setTriggerElement] = useState(+new Date())
    const loggedInUser = useSelector((state) => state.Profile.user)
    const currentProjectRole = useSelector((state) => state.Roles.currentProjectRole)
    const [paginationObject, setPaginationObject] = useState({});
    const [isOpenSweetAlert, setIsOpenSweetAlert] = useState(false);
    const [selectedRow, setSelectedRow] = useState();
    const [action, setAction] = useState()
    const hasTeamMemberRemovePermission = hasModulePermission(
        Modules.TEAM,
        Action.DELETE
    );
    const hasTeamMemberEditPermission = hasModulePermission(Modules.TEAM, Action.EDIT)
    const hasTeamMemberCreatePermission = hasModulePermission(
        Modules.TEAM,
        Action.CREATE
    );
    const [deletePayload, setDeletePayload] = useState({})
    const [tableColumns, setTableColumns] = useState([])
    useEffect(() => {
        getAllTeamMembers({ page: page + 1, perPage: rowsPerPage })
        if (!mounted) {
            setMounted((true))
        }
    }, [triggerElement])

    useEffect(() => {
        if (mounted) {
            if (page !== 0) {
                setPage(0)
                setTriggerElement(+new Date())
            } else {
                setTriggerElement(+new Date())
            }
        }
    }, [rowsPerPage])

    useEffect(() => {
        if (mounted) {
            setTriggerElement(+new Date())
        }
    }, [page])

    // Pagination Operation
    const handleChangePage = async (event, newPage) => {
        setTeamMembers([])
        setPage(newPage);
    };

    const handleChangeRowsPerPage = async (event) => {
        setTeamMembers([])
        const perPage = parseInt(event.target.value);
        setRowsPerPage(perPage);
    };


    const getAllTeamMembers = async (params = { page: 0, perPage: rowsPerPage }) => {
        try {
            setIsLoading(true)
            const res = (await getContactList({
                ...params,
                projectId: parseInt(projectId)
            })).data.data

            let level = ((page + 1) - 1) * rowsPerPage
            const resultData = (res.data).map((res) => {
                return {
                    indexNo: ++level,
                    id: res.id,
                    name: `${res.firstName} ${res.lastName}`,
                    email: res.email,
                    contactNo: res.contactNo ?? '',
                    position: res.position ?? '',
                    profilePicture: res?.profilePicture,
                    firstName: res?.firstName,
                    lastName: res?.lastName
                }
            })
            setTeamMembers(resultData)
            setRowCountState(res.meta.total)
            setPaginationObject(res.meta)
            setIsLoading(false)
        } catch (error) {
            setIsLoading(false)
            console.log(error)
        }
    }    

    const colums = [
        {
            field: "index",
            headerName: "#",
            width: 85,
            filterable: false,
            sortable: true,
            renderCell: (params) => (
                <div style={{ display: "flex", alignItems: "center", width: '100%' }}>
                    <div className="MuiDataGrid-cellContent">
                        {params.row?.indexNo}
                    </div>
                </div>
            ),
        },
        {
            field: "name",
            headerName: t("Name"),
            width: 180,
            filterable: false,
            sortable: true,
            renderCell: (params) => (
                <div style={{ display: "flex", alignItems: "center", width: '100%' }}>
                    <div className="MuiDataGrid-cellContent d-flex">
                    <UserProfile user={params.row} avatarClassName="mt-1" profileClassName="mt-1"/>
                        <span className="m-2">{params.row?.name}</span>
                    </div>
                </div>
            ),
        },
        {
            field: "email",
            headerName: t("Email"),
            width: 250,
            filterable: true,
            sortable: true,
            renderCell: (params) => (
                <div style={{ display: "flex", alignItems: "center", width: '100%' }}>
                    <div className="MuiDataGrid-cellContent">
                        <span className="">{params.row?.email}</span>
                    </div>
                </div>
            ),
        },
        {
            field: "contactNo",
            headerName: t("Contact"),
            width: 205,
            filterable: false,
            sortable: true,
            renderCell: (params) => (
                <div style={{ display: "flex", alignItems: "center", width: '100%' }}>
                    <div className="MuiDataGrid-cellContent">
                        <span className="">{params.row?.contactNo}</span>
                    </div>
                </div>
            ),
        },
        {
            field: "position",
            headerName: "Position",
            width: 200,
            filterable: false,
            sortable: true,
            renderCell: (params) => (
                <div style={{ display: "flex", alignItems: "center" }}>
                    <div className="MuiDataGrid-cellContent">
                        {params.row?.position}
                    </div>
                </div>
            ),
        },
        {
            field: "actions",
            headerName: t("Action"),
            width: 150,
            sortable: false,
            filterable: false,
            hideable: false,
            renderCell: (params) => (
                <div
                    className="proSubmissionActions"
                    style={{ display: "flex", alignItems: "center" }}
                >
                    {hasTeamMemberEditPermission &&
                        <EditOutlined style={{ fill: '#6B7083' }} onClick={() => {
                            handleOpenTeamMemberPopup()
                            setSelectedRow(params.row)
                        }}>
                            <img src={EditIcon} alt={EditIcon} />
                        </EditOutlined>
                    }
                    <DeleteOutlineOutlinedIcon id="deleteTeamMemberf"
                        key={`del-id-${params.row.id}`}
                        sx={{ cursor: !disabled ? 'pointer' : undefined }}
                        onClick={
                            (e) => {
                                e.stopPropagation()
                                handleClick(params, Action.DELETE)
                            }}
                    ></DeleteOutlineOutlinedIcon>
                </div>
            ),
        },
    ]

    // filter columns when page is mounted
    useEffect(() => {
        // remove action column when project is not draft or rejected status
        if (disabled || !hasTeamMemberRemovePermission || (![ProjectStatuses.DRAFT, ProjectStatuses.REJECTED, ProjectStatuses.CONFIRMATION_REJECTED, ProjectStatuses.ONGOING].includes(projectStatus))) {
            setTableColumns(colums.filter((eachColumn) => eachColumn.field !== "actions"))
        }
        else {
            setTableColumns(colums)
        }
    }, [])
    const handleClick = (params, action) => {
        if (action === Action.DELETE) {
            const payload = {
                projectId: parseInt(projectId),
                id: params?.id
            }
            setDeletePayload(payload)
            setIsOpenSweetAlert(true)
        }
    };

    const deleteTeamMember = async () => {
        try {
            const res = await deleteContact(deletePayload?.id, { projectId: deletePayload?.projectId })
            if (res.statusCode === 200) {
                toast.success(res.data.message)
                setPage(0)
                setTeamMembers([])
                setTriggerElement(+new Date())
            }
        } catch (err) {
            toast.error(err.message)
        }
        finally {
            setIsOpenSweetAlert(false)
        }
    }

    const handleOpenTeamMemberPopup = () => {
        setTeamMemberPopupOpen(true);
    };

    const handleCloseTeamMemberPopup = (data, reason) => {
        if (reason === 'backdropClick') {
            return;
        }
        setTeamMemberPopupOpen(data);
    };
    const handleAddTeamMember = async () => {
        setTeamMembers([])
        setSelectedRow()
        setTeamMemberPopupOpen(false)
        if (page > 0) {
            setPage(0)
        } else {
            await getAllTeamMembers({ page: 0, perPage: rowsPerPage })
        }
    };
    const getRowId = (row) => row.id;

    const handleSortModelChange = useCallback(async (sortModel) => {
        if (sortModel && sortModel.length > 0) {
            setSortOrder(sortModel[0]?.field)
            setSortDirection(sortModel[0]?.sort)
        }
        else {
            // handle unsort when sortModel array is length of zero
            setSortOrder(undefined)
            setSortDirection(undefined)
        }
        setTriggerElement(+new Date())
    }, []);

    const handleFilterModelChange = useCallback(
        debounce((searchModel) => {
            if (searchModel && searchModel.items.length > 0) {
                setSearchField(searchModel.items[0]?.field)
                setSearchValue(searchModel.items[0]?.value)
                setTriggerElement(+new Date())
            }
        }, 1200), [])

    const handlePaginationModelChange = (newPaginationModel) => {
        setPage(newPaginationModel.page);

        if (rowsPerPage !== newPaginationModel.pageSize) {
            setRowsPerPage(newPaginationModel.pageSize);
        }
        setTriggerElement(+new Date())
    };
    return (
        <div className="projectSubmission teamTable customTabCard">
            {/* <Container fluid> */}
            {/* BreadCrumb area starts */}
            <div className="mainPageHeader d-flex justify-content-between mb-4">
                <BreadCrumb title={t("Team Details")} />
                {/** enable only project status is draft or rejected state */}
                {!disabled && ([ProjectStatuses.DRAFT, ProjectStatuses.REJECTED, ProjectStatuses.ONGOING, ProjectStatuses.CONFIRMATION_REJECTED].includes(projectStatus)) && hasTeamMemberCreatePermission && (
                    <Button
                        variant="contained"
                        className="popupButton edit_button main-login-btn btn btn-secondary d-flex align-items-center btn btn-secondary btn-height-30"
                        disableElevation
                        onClick={handleOpenTeamMemberPopup}
                        startIcon={<AddOutlinedIcon />}
                    >
                         {t("Team Member")}
                    </Button>
                )}
            </div>
            <Card className="viewProjectApproval" style={{ height: 'auto', width: "100%", border: 'none' }}>
                {
                    teamMembers.length > 0 && (
                        <DataGrid
                            columns={tableColumns}
                            rows={teamMembers}
                            // style={{ height: "500px",border: 'none' }}
                            initialState={{
                                pagination: {
                                    paginationModel: { pageSize: rowsPerPage },
                                },
                            }}
                            disableRowSelectionOnClick
                            pageSizeOptions={PerPage}
                            sortingMode="server"
                            paginationMode="server"
                            filterMode="server"
                            onFilterModelChange={handleFilterModelChange}
                            rowCount={rowCountState}
                            onPaginationModelChange={handlePaginationModelChange}
                            getRowId={getRowId}
                            onSortModelChange={handleSortModelChange}
                            loading={isLoading}
                            hideFooter={true}
                        />
                    )}
                    {teamMembers.length > 0 && (
                    <div className="ongoingProjPagination d-flex justify-content-end mt-3 newRoundedPagination">
                        <PaginationComponent
                        paginationObject={paginationObject}
                        page={page}
                        handleChangePage={handleChangePage}
                        rowsPerPage={rowsPerPage}
                        handleChangeRowsPerPage={handleChangeRowsPerPage}
                        />
                    </div>
                    )}
                {teamMembers.length === 0 && !isLoading && (
                    // <div className="text-center p-4">No data found</div>
                    <NodataFound text={t("No data found")} icon={Ticket} />
                )}
                {isLoading && teamMembers.length === 0 && (
                    <Col md={12}>
                        <Row className="p-2">
                            <Col md={12}>
                                <Skeleton
                                    variant="rounded"
                                    className="p-2 m-2 h-75"
                                ></Skeleton>
                            </Col>
                        </Row>
                        <Row className="p-2">
                            <Col md={12}>
                                <Skeleton
                                    variant="rounded"
                                    className="p-2 m-2 h-75"
                                ></Skeleton>
                            </Col>
                        </Row>
                        <Row className="p-2">
                            <Col md={12}>
                                <Skeleton
                                    variant="rounded"
                                    className="p-2 m-2 h-75"
                                ></Skeleton>
                            </Col>
                        </Row>
                    </Col>
                )}
            </Card>
            {/* </Container> */}
            {/* Add Team Member Dialog */}
            {/* <AddTeamMember
                projectId={projectId}
                open={isTeamMemberPopupOpen}
                onClose={handleCloseTeamMemberPopup}
                onAddTeamMember={handleAddTeamMember}
            /> */}

            <AddTeamMemberDrawer
                projectId={projectId ? parseInt(projectId) : ''}
                isOpenProfileDetail={isTeamMemberPopupOpen}
                toggle={handleCloseTeamMemberPopup}
                refresh={handleAddTeamMember}
                selectedRow={selectedRow}
            />

            {/** Delete team member */}
            {isOpenSweetAlert && (

                <SweetAlert
                    title={t("Are you sure you want to delete this member") + "?"}
                    warning
                    showCancel
                    confirmBtnText={t("OK")}
                    cancelBtnText={t("Cancel")}
                    confirmBtnBsStyle="success"
                    cancelBtnBsStyle="danger"
                    onConfirm={async () => {
                        await deleteTeamMember()
                    }}
                    onCancel={() => {
                        setIsOpenSweetAlert(false)
                    }}>
                </SweetAlert>
            )}


        </div>
    );
}

export default withTranslation()(DataTable);